<template>
  <div>
    <LoadingIcon v-if="isLoading" size="lg" />

    <div v-else >
      <div
        v-if="!coursesWithCertificateAvailable.length"
        class="alert border-info text-info"
      >
        Você ainda não possui cursos concluídos.
      </div>

      <div class="row">
        <div
          v-for="course in coursesWithCertificateAvailable"
          :key="course.id"
          class="col-12 col-sm-6  mb-3"
        >
          <div class="course-certificate-box">
            <CourseBasicItem :course="course">
              {{ course.name }}
            </CourseBasicItem>

            <!-- <CourseProgressBar
              :percent="course.attended_percent"
              class="my-4"
            /> -->

            <ObtainCourseCertificateButtons :course="course" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import LoadingIcon from '@/components/layout/LoadingIcon'
  import CourseBasicItem from '@/components/course/CourseBasicItem'
  // import CourseProgressBar from '@/components/course/CourseProgressBar'
  import { generateCourseCertificate } from '@/api/course.api.js'
  import ObtainCourseCertificateButtons from '@/components/course/certificate/ObtainCourseCertificateButtons';

  export default {
    components: {
      LoadingIcon,
      CourseBasicItem,
      // CourseProgressBar,
      ObtainCourseCertificateButtons,
    },

    data: () => ({
      isLoading: true
    }),

    async mounted () {
      this.isLoading = true

      await this.fetchUserCoursesWithCertificateAvailable()

      this.isLoading = false
    },

    computed: {
      ...mapGetters('course', ['coursesWithCertificateAvailable'])
    },

    methods: {
      ...mapActions('course', [
        'fetchUserCoursesWithCertificateAvailable',
        'generateCourseCertificate'
      ]),

      async getCourseCertificate(courseId) {
        this.isLoading = true

        const response = await generateCourseCertificate(courseId)

        window.open(response)

        this.isLoading = false
      }
    }
  } 
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .course-certificate-box {
    background-color: $purple20;
    padding: 8px;
    border-radius: 8px;
  }
</style>
